import { getToken, setToken, clearAuthData } from '../utils/cookieUtils';

export const authManager = {
  login: (userData, token) => {
    setToken(token);
    localStorage.setItem('logged_user_id', userData.id || '');
    localStorage.setItem('role', userData.role || '');

    if (userData) {
      localStorage.setItem('user_data', JSON.stringify(userData));
    }

    localStorage.setItem('isAuthenticated', 'true');
  },

  logout: () => {
    clearAuthData();
  },

  isLoggedIn: () => {
    return Boolean(getToken());
  },

  getRole: () => {
    return localStorage.getItem('role');
  },

  getUserData: () => {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      try {
        return JSON.parse(userData);
      } catch {
        return null;
      }
    }
    return null;
  },

  getToken: () => {
    return getToken();
  },
};
